// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Language } from '../types/languages'

export const getRadioChannelLanguages = (domain: string, serviceSpec: string): Promise<ResponseAPI<Language>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/radio/languages`)
